import { compose, withProps } from 'recompose';
import NumberInput from '@/se/components/inputs/NumberInput';

export default compose(withProps({ label: 'Timeout (in seconds)', placeholder: 'e.g., 600', required: true }))(
  NumberInput
);
